/* eslint-disable camelcase */
import { ActionMap } from "../Config.store";

export type UserStateProps = {
  document: string;
  store?: string;
  username?: string;
  hasStore?: boolean;
  password?: string;
};

export interface LoginProps {
  document: string;
  store?: string;
  username?: string;
  hasStore?: boolean;
  password: string;
}

export const UserState = {
  document: "",
  password: "",
  hasStore: false,
  store: "",
  username: "",
};

export enum Types {
  CleanLogin = "CLEAN_LOGIN",
  SetPropertie = "SET_PROPERTIE",
  SetLogin = "SET_LOGIN",
}

export type UserPayload = {
  [Types.CleanLogin]: undefined,
  
  [Types.SetLogin]: {
    document?: string;
    username?: string;
    hasStore?: boolean;
  }

  [Types.SetPropertie]: {
    [key: string]: string | boolean;
  };
};

export type UserAction = ActionMap<UserPayload>[keyof ActionMap<UserPayload>];
